import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetEventHistoryList = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_HISTORY_CASHIER
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetEventHistoryListAction({
                    list: data.data.list,
                    count: data.data.count
                }));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetEventHistoryList as SetGetEventHistoryList
}